import Vue from 'vue'
import * as Sentry from '@sentry/browser'

Sentry.init({
  Vue,
  dsn: 'https://244622d094bb4b73b44618777adaa00f@o911515.ingest.sentry.io/6103962'
})
